// Global
var body       = document.querySelector('body'),
header         = document.querySelector('.js-header'),
headerWatcher  = scrollMonitor.create(1),
menu           = document.querySelector('.js-menu'),
menuToggles    = document.querySelectorAll('.js-menu-toggle'),
productToggle  = document.querySelector('.js-product-toggle'),
productWraps   = document.querySelectorAll('.js-product-wrap'),
globalClose    = document.querySelector('.global-close'),
menuModalOpen  = false,
videoModalOpen = false;

  // Header
  headerWatcher.exitViewport(() => {
    if (!header.classList.contains('header--fixed')) {
      header.classList.add('header--fixed');
      globalClose.classList.add('global-close--fixed-header');
    }
  });
  headerWatcher.enterViewport(() => {
    if (header.classList.contains('header--fixed')) {
      header.classList.remove('header--fixed');
      globalClose.classList.remove('global-close--fixed-header');
    }
  });

  // Menu
  for (var i = 0; i < menuToggles.length; i++) {
    menuToggles[i].addEventListener('click', e => {
      e.preventDefault();
      if (videoModalOpen) {
        toggleVideoModal();
      }
      toggleMenuModal();
    });
  }

  if (productToggle != null)
  {
	  productToggle.addEventListener('click', e => {
	    e.preventDefault();
	    productToggle.classList.toggle('menu__nav-link--active');
	    for (var i = 0; i < productWraps.length; i++) {
	      productWraps[i].classList.toggle('menu__product-wrap--active');
	    }
	  });
  }

  function toggleMenuModal() {
    menuModalOpen = !menuModalOpen;
    menu.classList.toggle('menu--active');
    body.classList.toggle('is-frozen');
    transformicons.toggle(globalClose);
    globalClose.classList.toggle('global-close--transformed')
    if (productToggle != null)
    {
	    if (productToggle.classList.contains('menu__nav-link--active')) {
	      productToggle.classList.remove('menu__nav-link--active');
	      for (var i = 0; i < productWraps.length; i++) {
	        productWraps[i].classList.remove('menu__product-wrap--active');
	      }
	    }
	}
  }

// Splash
var splash, layers, parallax;
if (splash = document.querySelector('.js-splash')) {
  layers = document.querySelectorAll('.layer');
  parallaxControl()
}

function parallaxControl() {
  if (!isMediumSize() && splash != null) {
    if (parallax != null) {
      parallax.enable();
      parallax.updateLayers()
    }
    else {
      parallax = new Parallax(splash);
    }
  }
  else {
    if (parallax != null) {
      parallax.disable();
      for (i = 0; i < layers.length; i++) {
        layers[i].removeAttribute('style');
      }
    }
  }
}

// down arrow
if ($('#down').length > 0)
{
  $('#down').click(function(){
  	console.log( $('.down_target').offset().top - parseInt($('.header').css('height')) );
	$('html, body').stop().animate({
        'scrollTop': $('.down_target').offset().top - parseInt($('.header').css('height'))
    }, 700, 'swing', function () {
        window.location.hash = '';
    });
	return false;
  });
}

// Video
function reloadVideoModal()
{
  console.log('reload video');
  var html = $('.video-modal__player').html();
  $('.video-modal__player').html(html);
}

var videoModal;
if (videoModal = document.querySelector('.js-video-modal')) {
  var videoModalToggles = document.querySelectorAll('.js-video-modal-toggle');

  for (var i = 0; i < videoModalToggles.length; i++) {
    videoModalToggles[i].addEventListener('click', e => {
      e.preventDefault();
      toggleVideoModal();
    });
  }
}

function toggleVideoModal () {
  videoModalOpen = !videoModalOpen;
  videoModal.classList.toggle('video-modal--active');
  body.classList.toggle('is-frozen');

  if (!videoModalOpen) {
    reloadVideoModal();
  }
}

// About
var instafeedEl;
if (instafeedEl = document.querySelector('.instagram')) {
  if (Instafeed) {
    var feed = new Instafeed({
      clientId: '12544c35abdc4b229ed510c41ec21a8e',
      get: 'user',
      userId: '2158499482',
      target: document.querySelector('.instagram'),
      template: '<a class="instagram__link" href="{{link}}"><img class="instagram__photo" src="{{image}}"></a>',
      resolution: 'standard_resolution',
      limit: 8
    });
    feed.run();
  }
}

var jobEls = document.querySelectorAll('.js-job');
if (jobEls.length > 0) {
  for (var i = 0; i < jobEls.length; i++) {
    (function () {
      var jobToggle = jobEls[i].querySelector('.js-job-toggle');
      var jobIcon = jobEls[i].querySelector('.js-job-icon');
      var jobParent = jobEls[i];
      jobToggle.addEventListener('click', (e) => {
        e.preventDefault();
        jobParent.classList.toggle('job--active');
        transformicons.toggle(jobIcon);
      });
    }());
  }
}

// SVG
jQuery('img.svg').each(function(){
    var $img = jQuery(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    jQuery.get(imgURL, function(data) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find('svg');

        // Add replaced image's ID to the new SVG
        if(typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if(typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass+' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Replace image with new SVG
        $img.replaceWith($svg);
    }, 'xml');
});

// Helpers

// Note: fires while resizing, should add a debounce to this
window.onresize = debounce(() => {
  headerWatcher.watchItem = setHeaderWatcherSize();
  parallaxControl();
}, 200);

function setHeaderWatcherSize() {
  return isSmallSize() ? 1 : 30;
}

function isSmallSize() {
  return window.innerWidth < 576;
}

function isMediumSize() {
  return window.innerWidth < 767;
}
